/** @jsxImportSource @emotion/react */

const SmartMatchMeterInfoIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
  >
    <path
      d="M7.33325 6H8.66658V4.66667H7.33325M7.99992 13.3333C5.05992 13.3333 2.66659 10.94 2.66659 8C2.66659 5.06 5.05992 2.66667 7.99992 2.66667C10.9399 2.66667 13.3333 5.06 13.3333 8C13.3333 10.94 10.9399 13.3333 7.99992 13.3333ZM7.99992 1.33334C7.12444 1.33334 6.25753 1.50577 5.4487 1.84081C4.63986 2.17584 3.90493 2.6669 3.28587 3.28596C2.03563 4.5362 1.33325 6.23189 1.33325 8C1.33325 9.76811 2.03563 11.4638 3.28587 12.714C3.90493 13.3331 4.63986 13.8242 5.4487 14.1592C6.25753 14.4942 7.12444 14.6667 7.99992 14.6667C9.76803 14.6667 11.4637 13.9643 12.714 12.714C13.9642 11.4638 14.6666 9.76811 14.6666 8C14.6666 7.12452 14.4941 6.25762 14.1591 5.44878C13.8241 4.63994 13.333 3.90501 12.714 3.28596C12.0949 2.6669 11.36 2.17584 10.5511 1.84081C9.7423 1.50577 8.8754 1.33334 7.99992 1.33334ZM7.33325 11.3333H8.66658V7.33334H7.33325V11.3333Z"
      fill="#9F9FA5"
    />
  </svg>
);

export default SmartMatchMeterInfoIcon;
